import cx from 'classnames'
import type React from 'react'

import css from '../../styles.module.scss'
import type { ChartBar } from '../../useDailyUsageChart'

interface ChartBarsProps {
  bars: ChartBar[]
}

export const ChartBars: React.FC<ChartBarsProps> = ({ bars }) => (
  <div className={css.bars}>
    {bars.map((bar) => (
      <div key={bar.key} className={css.bar_col} title={bar.tooltip}>
        <div
          className={css.bar_write}
          style={{ height: `${bar.writePercent}%` }}
        />
        <div
          className={cx(css.bar_read, {
            [css.bar_top]: bar.write === 0,
          })}
          style={{ height: `${bar.readPercent}%` }}
        />
      </div>
    ))}
  </div>
)
